export { default as ListadoComisiones } from "./Listado";
export { default as DetalleComisiones } from "./Detalle";
